// jw: let's try to chase the element for at most 3 seconds. This matches the resize observation
//     window above.
const ELEMENT_CHASING_ATTEMPTS = 6;

export default {
  data() {
    return {
      $_tabsParentId: 'pdpTabsParent',
    };
  },
  methods: {
    $_scrollToElement(element, attempts = 0, providedTop = null) {
      if (!element || attempts >= ELEMENT_CHASING_ATTEMPTS) {
        return;
      }

      const top = providedTop || this.$_calculateTop(element);

      // an: Using setTimeout as a workaround to scroll only after the hash has been set
      // Guess browser waits for the event 'hashchange_event' to be completed
      // https://developer.mozilla.org/en-US/docs/Web/API/Window/hashchange_event
      if ('scrollBehavior' in document.documentElement.style) {
        setTimeout(() => window.scrollTo({ top }));
      } else {
        setTimeout(() => window.scrollTo(0, top));
      }
    },
    $_calculateTop(element) {
      const currentScrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
      let top = element.getBoundingClientRect().top + window.pageYOffset;

      // an: The nav is sticky only when scrolling up
      // so we need to account for that in these calculations
      if (top < currentScrollPosition) {
        top -= document.querySelector('header > nav').offsetHeight;
      }

      // Take into account the tabs Height (sticky)
      top -= document.getElementById(this.$data.$_tabsParentId).offsetHeight;

      // space to breath between Tab section and the top of the section
      const scrollGap = 15;
      top -= scrollGap;

      return top;
    },
  },
};
